module.exports = __webpack_public_path__ + "7f8b249eb098ce855416528b1658e9bc.pdf";